import { WHITE_LABEL_CONFIG } from "@/src_new/whiteLabel";
import { App_Url_New } from "../common/static";
import { NavItemType } from "../types/header";

export const HEADER_CONFIG: {
  brand: {
    link: string;
  };
  phone: {
    label: string;
    value: string;
  };
  navigation: NavItemType[];
} = {
  brand: {
    link: App_Url_New.secured.frontlinks.login,
  },

  phone: {
    label: WHITE_LABEL_CONFIG.contact.phoneLabel,
    value: WHITE_LABEL_CONFIG.contact.phoneValue,
  },

  navigation: [
    {
      label: "Services",
      children: [
        { label: "Claims", path: App_Url_New.frontLinks.services.claims },
        {
          label: "Roadside Assistance",
          path: App_Url_New.frontLinks.services.roadsideAssistance,
        },
        { label: "Complaints", path: App_Url_New.frontLinks.services.complaints },
      ],
    },
    {
      label: "About Us",
      path: App_Url_New.frontLinks.aboutUs,
    },
  ],
};
